export default __webpack_public_path__ + "a244fc778e66dad620346f4a9221ef0f.png";